import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { interval, map } from 'rxjs';

@Component({
	selector: 'app-report-pending-info',
	standalone: true,
	imports: [MatProgressSpinnerModule],
	template: `<div class="alert alert-info d-flex align-items-center gap-3">
		<mat-spinner diameter="28"></mat-spinner>
		<div>
			<div>{{ label() }}...</div>
			<small class="text-muted">
				Nie powinno to trwać dłużej niż minutę. Nie zamykaj okna. ({{ elapsedSeconds() }} s)
			</small>
		</div>
	</div>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportPendingInfoComponent {
	readonly label = input.required<string>();
	readonly elapsedSeconds = toSignal(interval(1000).pipe(map((tick) => tick + 1)), { initialValue: 0 });
}
